abstract class PaymentOffset {

  public getValue(): number {
    return Object.getPrototypeOf(this).constructor.value;
  }
}

export { PaymentOffset }
